<template>
    <b-card border-variant="dark">
      <div class="height-queue">
        <span class="font-weight-bold font-15">Detalhes da Fila</span>
        <b-table id="queue" small striped bordered fixed :per-page="perPage"
                 :fields="fields" :items="items" responsive="sm" class="mt-2"
                 :current-page="currentPage" show-empty>
          <template #empty="scope">
            <h6 class="text-center">Nenhum cliente na fila</h6>
          </template>

          <template #cell(queue)="data">
            <span :class="data.item.queue == 'Atendimento Ativo' ? 'text-danger font-weight-bold' : ''">{{ data.item.queue }}</span>
          </template>
        </b-table>
        <b-pagination v-model="currentPage" pills :total-rows="rows" :per-page="perPage" aria-controls="queue" size="sm" align="right"></b-pagination>
        </div>
    </b-card>
  </template>
  
<script>
const socket = require('./../../../modules/realtime/service/service');

const onQueueDetail = function (obj) {
  this.queues = obj.queues;
};

export default {
  name: "TbFilaDetail",

  data: () => ({
    fields: [
      {key: 'queue', label: 'Fila', class: 'text-center align-middle', thStyle: {'font-weight': 'bold', padding: '3px'}},
      {key: 'atendimento', label: 'Atendimento', class: 'text-center align-middle', thStyle: {'font-weight': 'bold', padding: '3px'}},
      {key: 'aguardando', label: 'Aguardando', class: 'text-center align-middle', thStyle: {'font-weight': 'bold', padding: '3px'}},
    ],
    currentPage: 1,
    perPage: 10,
    queues: [],
    userChatQueues: [],
    _realtimeJoined: false,
    _onQueueDetailBound: null,
    _onReconnectBound: null
  }),

  mounted() {
    axios.get('/user-chat-queues').then(({data}) => {
      this.userChatQueues = data;
      this.userChatQueues.push('entrante');
    });

    this.joinRealtime();
  },

  beforeDestroy() { this.leaveRealtime(); },
  deactivated()   { this.leaveRealtime(); },
  activated()     { this.joinRealtime(); },

  computed: {
    items() {
      const lista = [];
      this.queues.map(q => {
        if (this.userChatQueues.indexOf(q.queue) !== -1 && q.queue !== 'Ativos') {
          lista.push({
            queue: (q.queue === 'entrante') ? 'Atendimento Ativo' : q.queue,
            atendimento: q.atendimento,
            aguardando: q.aguardando
          });
        }
      });
      lista.sort(function (x, y) {
        const a = x.queue.toUpperCase(), b = y.queue.toUpperCase();
        return a === b ? 0 : (a > b ? 1 : -1);
      });
      return lista;
    },
    rows() { return this.items.length; }
  },

  methods: {
    joinRealtime() {
      if (this._realtimeJoined) return;

      socket.connection.emit('realtime:join');

      this._onQueueDetailBound = onQueueDetail.bind(this);
      socket.connection.on('queueDetail', this._onQueueDetailBound);

      this._onReconnectBound = () => {
        if (this._realtimeJoined) socket.connection.emit('realtime:join');
      };
      socket.connection.on('connect', this._onReconnectBound);

      this._realtimeJoined = true;
    },

    leaveRealtime() {
      if (!this._realtimeJoined) return;

      socket.connection.emit('realtime:leave');

      if (this._onQueueDetailBound) {
        if (socket.connection.off) socket.connection.off('queueDetail', this._onQueueDetailBound);
        else socket.connection.removeListener('queueDetail', this._onQueueDetailBound);
        this._onQueueDetailBound = null;
      }
      if (this._onReconnectBound) {
        if (socket.connection.off) socket.connection.off('connect', this._onReconnectBound);
        else socket.connection.removeListener('connect', this._onReconnectBound);
        this._onReconnectBound = null;
      }

      this._realtimeJoined = false;
    }
  },

  watch: {
    queues() { }
  }
};
</script>

  <style scoped>
    .card {
      color: black !important;
      border: 1px solid rgba(0, 0, 0, 0.125) !important;
      border-radius: 0.25rem !important;
    }
    .font-15 {
      font-size: 15px;
    }
    .height-queue {
      /* height: 205px; */
    }
  </style>